import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getProductiveCycleList as getProductiveCycleListApi,
	getProductiveCycle as getProductiveCycleApi,
	addNewProductiveCycle as addNewProductiveCycleApi,
	updateProductiveCycle as updateProductiveCycleApi,
	deleteProductiveCycle as deleteProductiveCycleApi,
	getProductiveCycleQuery as getProductiveCycleQueryApi,
} from '../../helpers/establishment/backend_helper';

export const getProductiveCycleList = createAsyncThunk(
	'productiveCycle/getProductiveCycleList',
	async () => {
		try {
			const response = getProductiveCycleListApi();
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getProductiveCycleQuery = createAsyncThunk(
	'productiveCycle/getProductiveCycleQueryList',
	async query => {
		try {
			const response = getProductiveCycleQueryApi(query);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getProductiveCycle = createAsyncThunk(
	'productiveCycle/getProductiveCycle',
	async productive_cycle_id => {
		try {
			const response = getProductiveCycleApi(productive_cycle_id);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const addNewProductiveCycle = createAsyncThunk(
	'productiveCycle/addNewProductiveCycle',
	async productive_cycle => {
		try {
			const response = addNewProductiveCycleApi(productive_cycle);
			toast.success('Ciclo Productivo agregado exitosamente.', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al agregar productive_cycle.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const updateProductiveCycle = createAsyncThunk(
	'productiveCycle/updateProductiveCycle',
	async productive_cycle => {
		try {
			const response = updateProductiveCycleApi(productive_cycle);
			toast.success('Ciclo Productivo actualizado exitosamente', {
				autoClose: 3000,
			});
			return response;
		} catch (error) {
			toast.error('Error al actualizar productive_cycle.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteProductiveCycle = createAsyncThunk(
	'productiveCycle/deleteProductiveCycle',
	async productive_cycle => {
		try {
			const response = await deleteProductiveCycleApi(productive_cycle);
			toast.success('Ciclo Productivo eliminado exitosamente.', {
				autoClose: 3000,
			});
			return { productive_cycle, ...response };
		} catch (error) {
			toast.error('Error al eliminar productive_cycle.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);
